var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowCard,
      expression: "isShowCard"
    }],
    staticClass: "personal-card",
    style: {
      top: "".concat(_vm.top ? parseInt(_vm.top) : '', "px"),
      left: "".concat(_vm.left ? "".concat(parseInt(_vm.left) + 330 >= 960 ? 630 : _vm.left) : '', "px")
    }
  }, [false ? _c('div', {
    staticClass: "card-report-btn",
    on: {
      "click": function click($event) {
        return _vm.changeReport();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('liveroom.personalCard.reportBtn')) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.showReport ? _c('card-report', {
    attrs: {
      "userInfo": _vm.userInfo
    },
    on: {
      "changeReport": _vm.changeReport,
      "feedbackSend": _vm.feedbackSend
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-close",
    on: {
      "click": function click($event) {
        return _vm.closeCard();
      }
    }
  }), _vm._v(" "), _c('card-head', {
    attrs: {
      "userInfo": _vm.userInfo,
      "videoid": _vm.videoid
    }
  }), _vm._v(" "), _c('card-follow', {
    attrs: {
      "userInfo": _vm.userInfo,
      "countInfo": _vm.countInfo
    }
  }), _vm._v(" "), _c('card-desc', {
    attrs: {
      "userInfo": _vm.userInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('div', {
    staticClass: "button",
    class: {
      'disabled': _vm.relationState
    },
    on: {
      "click": function click($event) {
        return _vm.followUser();
      }
    }
  }, [_vm._v(_vm._s(_vm.relationState ? _vm.$t('liveroom.unsubscribe') : _vm.$t('liveroom.subscribe')))])]), _vm._v(" "), _c('card-tip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tipInfo,
      expression: "tipInfo"
    }],
    attrs: {
      "width": "276px",
      "mleft": "-138px",
      "tipInfo": _vm.tipInfo
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };